import { Countdown } from "@jbnl/shared-ui";
import { useKorpsPeriodes } from "@/features/inschrijving/useInschrijving";
import { volgendePeriode } from "@/features/inschrijving/venster";

/** Renders nothing until there is a korps window that has not closed: a countdown to nothing answers nothing. */
export function InschrijfCountdown({
  seizoenId,
}: {
  seizoenId: string | undefined;
}) {
  const {
    data: periodes,
    dataUpdatedAt,
    refetch,
  } = useKorpsPeriodes(seizoenId);
  const periode = volgendePeriode(periodes);

  return (
    periode && (
      <Countdown
        opensOn={periode.opensOn}
        closesOn={periode.closesOn}
        serverNow={periode.serverNow}
        receivedAt={dataUpdatedAt}
        onPhaseChange={() => void refetch()}
      />
    )
  );
}
